import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export default function Ages(props) {
  const { yearCount, yearWidth } = props;
  const ages = [];
  for (let a = 0; a <= yearCount; a += 1) {
    ages.push(a);
  }

  return (
    <div style={{
      position: 'relative',
      display: 'flex',
      paddingBottom: '2px',
    }}
    >
      {ages.map((age) => {
        if (age % 5 !== 0) return null;
        return (
          <div
            key={age}
            style={{
              position: 'absolute',
              left: `${age * yearWidth}px`,
            }}
          >
            <div style={{
              width: '1px',
              height: '3px',
              backgroundColor: 'gray',
              transform: 'translate(-50%, 0)',
            }}
            />
            <Typography
              variant="body1"
              style={{
                transform: 'translate(-50%, 0)',
                width: `${yearWidth}px`,
                flexShrink: 0,
                fontSize: '0.70em',
              }}
            >
              {`Age ${age}`}
            </Typography>
          </div>
        );
      })}
    </div>
  );
}

Ages.propTypes = {
  yearWidth: PropTypes.number.isRequired,
  yearCount: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/lifeline/Line/Ages.jsx